import React, { useState, useEffect } from "react";
import "../assets/css/Dashboard.css";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getCompanyData,
  searchUser,
  getAdminPanelCountsAPI,
  getMostSearchedCount,
} from "../Service/apiService";
import CompanyDetails from "../Components/CompanyDetails.js";
import UserDetails from "../Components/UserDetails";
import LeadsDetails from "../Components/LeadDetails";
import DemoDetails from "../Components/DemoDetails";
import InvoicesDetails from "../Components/InvoicesDetails";
import UserActivityDetails from "../Components/UserActivityDetails";
import TopSearchedTermsDetails from "../Components/TopSearchedTermsDetails";

let cachedCounts = {
  companies: null,
  users: null,
  activities: null,
  leads: null,
  demos: null,
  invoices: null,
  topSearches: null,
};

export default function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const parts = location.pathname.split("/").filter(Boolean);

  const activeTab = parts[0] || "dashboard";
  const selectedMetric = parts[1] || null;

  const [companiesCount, setCompaniesCount] = useState(cachedCounts.companies);
  const [usersCount, setUsersCount] = useState(cachedCounts.users);
  const [activitiesCount, setActivitiesCount] = useState(
    cachedCounts.activities
  );
  const [leadsCount, setLeadsCount] = useState(cachedCounts.leads);
  const [demosCount, setDemosCount] = useState(cachedCounts.demos);
  const [invoicesCount, setInvoicesCount] = useState(cachedCounts.invoices);
  const [topSearchesCount, setTopSearchesCount] = useState(
    cachedCounts.topSearches
  );
  const [topSearchesData, setTopSearchesData] = useState(
    cachedCounts.topSearches || null
  );
  const [loading, setLoading] = useState(cachedCounts.companies === null);

  const formatNumber = (num) => {
    if (num == null) return "—";
    return Number(num).toLocaleString();
  };

  const handleNavigate = (id) => {
    if (activeTab === "analytics") {
      navigate(`/analytics/${id}`);
    } else {
      navigate(`/dashboard/${id}`);
    }
  };

  useEffect(() => {
    let mounted = true;

    const isNotInternal = (entity) =>
      (entity.companyType || "").toLowerCase() !== "internal";

    const parseDemoCount = (val) => {
      if (val == null) return 0;
      if (typeof val === "string" && val.startsWith(">")) return 6;
      const num = parseInt(val, 10);
      return isNaN(num) ? 0 : num;
    };

    const fetchAllCounts = async () => {
      setLoading(true);
      try {
        const companyRes = await getCompanyData("all");
        const companies = companyRes?.data || [];
        const nonInternalCompanies = companies.filter(isNotInternal);

        const userRes = await searchUser("?userDeleted=false", {
          industry: "",
        });
        const users = userRes?.result || [];
        const nonInternalUsers = users.filter(isNotInternal);

        const adminCounts = await getAdminPanelCountsAPI();

        //fe\tch top searched terms
        let topSearchesData = cachedCounts.topSearches || [];
        if (!cachedCounts.topSearches) {
          try {
            const searches = await getMostSearchedCount();
            topSearchesData = Array.isArray(searches) ? searches : [];
            cachedCounts.topSearches = topSearchesData;
            setTopSearchesData(topSearchesData);
          } catch (err) {
            console.warn("Failed to load top searches:", err);
            topSearchesData = [];
            setTopSearchesData([]);
          }
        } else {
          setTopSearchesData(cachedCounts.topSearches);
        }

        if (!mounted) return;

        const newCompanies = nonInternalCompanies.length;
        const newUsers = nonInternalUsers.length;
        const totalSearchCount = nonInternalUsers.reduce(
          (sum, user) =>
            sum +
            (typeof user?.searchCounts?.twelveMonthCount === "number"
              ? user.searchCounts.twelveMonthCount
              : 0),
          0
        );
        const totalDemos = nonInternalCompanies.reduce(
          (sum, company) => sum + parseDemoCount(company.demo),
          0
        );
        const totalInvoices = nonInternalCompanies.filter(
          (c) => c.invoiceDate
        ).length;

        setCompaniesCount(newCompanies);
        setUsersCount(newUsers);
        setActivitiesCount(totalSearchCount);
        setLeadsCount(adminCounts?.result?.totalCount ?? 0);
        setDemosCount(totalDemos);
        setInvoicesCount(totalInvoices);

        cachedCounts = {
          companies: newCompanies,
          users: newUsers,
          activities: totalSearchCount,
          leads: adminCounts?.result?.totalCount ?? 0,
          demos: totalDemos,
          invoices: totalInvoices,
          topSearches: topSearchesData,
        };
      } catch (err) {
        console.error("Failed to load dashboard counts:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchAllCounts();
    return () => (mounted = false);
  }, []);

  const metrics = [
    {
      id: "companies",
      title: "Total Companies",
      value: formatNumber(companiesCount),
      icon: "🏢",
    },
    {
      id: "users",
      title: "Total Users",
      value: formatNumber(usersCount),
      icon: "👥",
    },
    {
      id: "activity",
      title: "User Activities",
      value: formatNumber(activitiesCount),
      icon: "⚡",
    },
    {
      id: "leads",
      title: "Total Leads",
      value: formatNumber(leadsCount),
      icon: "📈",
    },
    { id: "demo", title: "Demos", value: formatNumber(demosCount), icon: "🎥" },
    {
      id: "invoices",
      title: "Invoices",
      value: formatNumber(invoicesCount),
      icon: "📄",
    },
    {
      id: "top-searches",
      title: "Top Searched Terms",
      value: loading ? "..." : "\u00A0",
    },
  ];

  return (
    <div className="dashboard-container">
      {/* Tabs */}
   {/* Top Navigation Tabs */}
<div className="daily-data-tabs">
  <button
    onClick={() =>
      navigate(
        selectedMetric ? `/analytics` : "/analytics"
      )
    }
    className={activeTab === "analytics" ? "tab-btn active" : "tab-btn"}
  >
    Analytics
  </button>
  <button
    onClick={() => navigate("/daily-data-table")}
    className={activeTab === "daily-data-table" ? "tab-btn active" : "tab-btn"}
  >
    Daily Data table
  </button>
    
  <button
    onClick={() =>
      navigate(
        selectedMetric ? `/dashboard/${selectedMetric}` : "/dashboard"
      )
    }
    className={activeTab === "dashboard" ? "tab-btn active" : "tab-btn"}
  >
    Dashboard
  </button>

</div>

      {/* Metric Cards */}
      <div className="metric-bar">
        {metrics.map((item) => (
          <div
            key={item.id}
            className={`metric-tab ${
              selectedMetric === item.id ? "active" : ""
            }`}
            onClick={() => handleNavigate(item.id)}
          >
            <p className="metric-title">{item.title}</p>
            <p className="metric-number">{item.value}</p>
          </div>
        ))}
      </div>

      <div className="metric-separator"></div>

      {/* Inline Detail Area */}
      <div className="content-area">
        {selectedMetric === "companies" && <CompanyDetails />}
        {selectedMetric === "users" && <UserDetails />}
        {selectedMetric === "leads" && <LeadsDetails />}
        {selectedMetric === "demo" && <DemoDetails />}
        {selectedMetric === "invoices" && <InvoicesDetails />}
        {selectedMetric === "activity" && <UserActivityDetails />}
        {selectedMetric === "top-searches" && (
          <TopSearchedTermsDetails initialData={topSearchesData} />
        )}
        {!selectedMetric && (
          <p className="content-placeholder">
            Select a metric above to view details.
          </p>
        )}
      </div>
    </div>
  );
}
